/**
 * BuildingDeckSplash — Phase 2.73
 *
 * Half-second "Building your study deck…" splash that sits on Quiz /
 * Flashcards pages while we auto-hydrate from the chapter pre-warm cache.
 * Why this isn't just a spinner: students don't know we already pre-baked
 * content for their chapter, so a blank-then-content jump reads as a bug
 * and makes them reach for the manual "Generate" button. A purposeful
 * splash says "we're assembling YOUR deck for THIS chapter" — the wait
 * feels intentional, not laggy.
 */
import { BookOpen, Loader2 } from 'lucide-react';

export default function BuildingDeckSplash({ kind = 'flashcards', subject, topic }) {
  // Quiz vs flashcards each get a slightly different line of copy so the
  // student knows what's coming.
  const label = kind === 'quiz' ? 'quiz' : 'study deck';
  const noun = kind === 'quiz' ? 'quiz' : 'flashcards';
  const chapter = topic || subject || 'this chapter';
  return (
    <div
      className="flex flex-col items-center justify-center gap-3 py-12"
      data-testid={`building-deck-splash-${kind}`}>
      <div className="relative">
        <BookOpen className="w-10 h-10 text-indigo-500" />
        <Loader2 className="w-4 h-4 text-amber-500 animate-spin absolute -bottom-1 -right-1" />
      </div>
      <p className="font-heading text-sm text-slate-700">
        Building your {label}…
      </p>
      <p className="text-[11px] text-slate-500 font-body text-center max-w-xs">
        Pulling the {noun} meant just for you for <span className="font-semibold text-slate-700">{chapter}</span> — sit tight, we&apos;re curating this one right now.
      </p>
    </div>
  );
}
